export default {
  data() {
    return {
      draggingEndTimeout: null,
    };
  },

  methods: {
    onDraggingEnd() {
      this.$store.dispatch('setDraggingEnd', true);
      clearTimeout(this.draggingEndTimeout);
      this.draggingEndTimeout = setTimeout(() => {
        this.$store.dispatch('setDraggingEnd', false);
        clearTimeout(this.draggingEndTimeout);
      }, 50);
    },
  },
};
